import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const USER_SETTINGS_FETCH = createAsyncActionTypes('USER_SETTINGS_FETCH');
export const UPDATE_USER_SETTINGS = createAsyncActionTypes('UPDATE_USER_SETTINGS');